module.exports = __webpack_public_path__ + "media/icons/re_black30-eb0f0fdb.png";